import {
  getEditVehicleApi,
  getInsuranceEditVehicleApi,
  addVehicleApi,
  documentUploadApi,
  documentDeleteApi,
  fetchLatLong
} from '../../../../config/apis';

const initialState = {};

export const vehicleEdit = {
  state: { ...initialState },
  reducers: {
    editSuccess(state, payload) {
      return {};
    },
    editFailed() {
      return { ...initialState };
    },
    getSuccess(state, payload) {
      return { ...payload };
    },
    getRecallSuccess(state, payload) {
      return { ...payload, vehicleDetails: state.vehicleDetails }
    },
    getFailed() {
      return { ...initialState };
    },
    updateLocalDocumentList(state, response) {
      const documents = state.documents.map((item) => {
        if (item.type.name === response?.response?.type?.name) {
          return { ...response.response };
        } else if (item.id === response?.id) {
          if (response?.isDelete) {
            return {
              ...item,
              id: null,
              name: null,
              url: null,
              uploaded: null,
              expiration_date: null
            };
          } else {
            return { ...item };
          }
        } else {
          return { ...item };
        }
      });
      return { ...state, documents: [...documents] };
    }
  },
  effects: (dispatch) => ({
    async fetchLatLongSave(payload, rootState) {
      try {
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: {
              ...fetchLatLong,
              url: fetchLatLong.url + `?address=${payload.address}`
            },
          },
          id: payload.latLongApiId
        });
        if (response && response?.lat) {
          let finalData = payload.data
          finalData.data.longitude = response?.lng
          finalData.data.latitude = response?.lat
          this.saveData({
            data: finalData,
            apiId: payload.apiId,
            callback: payload.callback
          })
        }else {
          payload.latLongCallback('error', payload.i18n.t('companyData.invalidGaragingAddress'));
        }
      } catch (error) {
        payload.latLongCallback('error', payload.i18n.t('companyData.invalidGaragingAddress'));
      }
    },
    async saveData(payload, rootState) {
      try {
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: addVehicleApi,
            data: payload.data.data
          },
          id: payload.apiId
        });
        if(response) {
          (response.status != 207) && dispatch.vehicles.updateListResponse(response);
          payload.callback && payload.callback(response && response.status == 207, response.data?.errors);
        }        
      } catch (error) {
          if (payload.callback) {
            const fromCatch = true
            payload.callback('error', error?.message || "An error occurred while saving!", fromCatch) 
          }
        // this.editFailed();
      }
    },
    async fetchData(payload, rootState) {
      try {
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: {
              ...getEditVehicleApi,
              url: getEditVehicleApi.url.replace('{id}', payload.data.id)
            }
          },
          id: payload.apiId,
          redirectionUrl: payload.redirectionUrl,
          callback: payload.callback,
          history: payload.history
        });
        if(response && response.fuelTypes) {
          let idx = response.fuelTypes.indexOf('Special Diesel')
          response.fuelTypes.splice(idx, 1)
          response.fuelTypes.splice(0, 0, 'Special Diesel')
        }
        this.getSuccess(response);
        const departments = response && {
          regions: response.regions,
          terminals: response.terminals,
          departments: response.departments,
          subDepartments: response.subDepartments
        }
        dispatch.regions.updateAll(departments);
      } catch (error) {
        this.getFailed();
      }
    },
    async fetchInsuranceUserData(payload, rootState) {
      try {
        let queryParam = '&'
        if (payload?.data?.company) queryParam += `companyId=${payload?.data?.company}`
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: {
              ...getInsuranceEditVehicleApi,
              url: getInsuranceEditVehicleApi.url.replace('{id}', payload.data.id) + `${queryParam.length > 1 ? queryParam : ''}`
            }
          },
          id: payload.apiId,
          redirectionUrl: payload.redirectionUrl,
          callback: payload.callback,
          history: payload.history
        });
        if (payload?.data?.recall) this.getRecallSuccess(response)
        else this.getSuccess(response)
        const departments = response && {
          regions: response.regions,
          terminals: response.terminals,
          departments: response.departments,
          subDepartments: response.subDepartments
        }
        dispatch.regions.updateAll(departments);
      } catch (error) {
        this.getFailed();
      }
    },
    async saveDocument(payload) {
      try {
        const data = payload.data.data;
        const response = await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: documentUploadApi,
            data: data
          },
          id: payload.apiId,
          callback: payload.callback
        });
        response && this.updateLocalDocumentList({ response });
      } catch (error) {
        this.saveFailed();
      }
    },
    async deleteDocument(payload) {
      try {
        const url = documentDeleteApi.url.split('{')[0];
        await dispatch.asyncRequests.handleAsyncRequests({
          payload: {
            api: { ...documentDeleteApi, url: url + payload.data.id }
          },
          id: payload.apiId
        });
        this.updateLocalDocumentList({
          isDelete: true,
          id: payload.data.id
        });
      } catch (error) {
        this.deleteFailed();
      }
    },
    async removeApiStatus(){
      try {
        await dispatch.asyncRequests.clearApiStatus();
      } catch (error) {}
    }
  })
};
